import { Box, Stack, Typography, TypographyProps } from '@mui/material';
import { ICellRendererParams } from 'ag-grid-community';
import { JSX } from 'react';
import { HBIcon } from '../HBIcon/HBIcon';
import { glyphy } from '@/core/utils/glyphy';

type GridAmountValueType = 'deposit' | 'withdraw' | 'normal' | 'auto';

export interface GridAmountCellPropType
  extends Pick<ICellRendererParams, 'value'>,
    Pick<TypographyProps, 'variant' | 'color' | 'justifyContent'> {
  type?: GridAmountValueType;
  emptyString?: string;
  arrowIconVisibility?: boolean;
  mapType?: Partial<Record<GridAmountValueType, GridAmountValueType>>;
  currency: string;
}

export const colors = {
  deposit: 'success.main',
  withdraw: 'error.main',
  normal: 'text.secondary',
};
export const HBGridAmountCell = (props: GridAmountCellPropType): JSX.Element => {
  const {
    value,
    type = 'normal',
    emptyString = '',
    variant = 'body1',
    justifyContent = 'center',
    color: propColor,
    arrowIconVisibility = true,
    mapType = {
      auto: 'auto',
      deposit: 'deposit',
      normal: 'normal',
      withdraw: 'withdraw',
      ...props.mapType,
    },
    currency,
  } = props;
  const mappedType: typeof type =
    type === 'auto'
      ? Number(value) > 0
        ? mapType.deposit || 'deposit'
        : Number(value) < 0
          ? mapType.withdraw || 'withdraw'
          : mapType.normal || 'normal'
      : mapType[type] || type;

  const color = colors[mappedType as keyof typeof colors] ?? 'text.secondary';
  const arrow = mappedType === 'withdraw' ? 'arrowDown' : 'arrowUp';

  return (
    <Stack justifyContent="center" sx={{ height: '100%' }}>
      <Typography
        alignItems="center"
        {...(value && { color: propColor || color })}
        component="bdi"
        display="flex"
        justifyContent={justifyContent}
        variant={variant}
      >
        {value ? (
          <>
            {arrowIconVisibility && mappedType && mappedType !== 'normal' && (
              <HBIcon size="medium" type={arrow} />
            )}
            <Box sx={{ direction: 'rtl', mr: 1 }}>{Number(value)?.toLocaleString()}</Box>
            <Box>{glyphy(currency, 'second-transform')}</Box>
          </>
        ) : (
          <Box>{emptyString}</Box>
        )}
      </Typography>
    </Stack>
  );
};
